import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static values = { text: String }

  copy(event) {
    const textToCopy = this.textValue || this.data.get("text") || this.element.textContent.trim()
    this.copyToClipboard(textToCopy)
  }

  copyFromInput(event) {
    const inputTarget = this.element.getAttribute("data-clipboard-input-target")
    const inputElement = document.querySelector(`[name="${inputTarget}"]`)
    
    if (inputElement && inputElement.value.trim()) {
      const textToCopy = `[image:${inputElement.value.trim()}]`
      this.copyToClipboard(textToCopy)
    }
  }

  copyToClipboard(textToCopy) {
    if (navigator.clipboard) {
      navigator.clipboard.writeText(textToCopy).then(() => {
        this.showCopiedMessage()
      }).catch(() => {
        this.fallbackCopyTextToClipboard(textToCopy)
      })
    } else {
      this.fallbackCopyTextToClipboard(textToCopy)
    }
  }

  fallbackCopyTextToClipboard(text) {
    const textArea = document.createElement("textarea")
    textArea.value = text
    textArea.style.top = "0"
    textArea.style.left = "0"
    textArea.style.position = "fixed"

    document.body.appendChild(textArea)
    textArea.focus()
    textArea.select()

    try {
      document.execCommand('copy')
      this.showCopiedMessage()
    } catch (err) {
      console.error('Fallback: Unable to copy', err)
    }

    document.body.removeChild(textArea)
  }

  showCopiedMessage() {
    const button = this.element
    const originalContent = button.innerHTML

    // Change button content temporarily
    button.innerHTML = '<i class="ph-fill ph-check text-green-600"></i>'
    button.disabled = true

    // Reset after 1 second
    setTimeout(() => {
      button.innerHTML = originalContent
      button.disabled = false
    }, 1000)

    // Show flash message notification
    this.showFlashMessage('Copied to clipboard!')
  }

  showFlashMessage(message) {
    const flashContainer = document.getElementById('flash_messages')
    if (!flashContainer) return

    // Generate unique ID for this flash message
    const flashId = `flash_${Date.now()}_${Math.random().toString(36).substr(2, 9)}`

    // Create flash message HTML matching the standard flash system
    const flashHTML = `
      <div id="${flashId}"
           class="bg-emerald-100 border border-emerald-400 text-emerald-700 px-4 py-3 rounded-lg shadow-lg w-full flash-message relative"
           role="alert"
           data-controller="flash"
           data-flash-auto-dismiss-value="true"
           data-flash-timeout-value="5000"
           data-action="mouseenter->flash#pauseAutoDismiss mouseleave->flash#resumeAutoDismiss"
           data-auto-dismiss="5000">
        <span class="flex items-center mr-4">
          <i class="ph-fill ph-check-circle text-emerald-600 w-5 h-5 mr-2 flex-shrink-0"></i>
          <span class="flex-1">${message}</span>
        </span>
        <button class="absolute top-2 right-2 w-6 h-6 flex items-center justify-center focus:outline-none hover:opacity-75 transition-opacity rounded"
                data-action="click->flash#dismiss"
                aria-label="Dismiss notification"
                title="Close">
          <i class="ph-bold ph-x text-sm text-navy-900"></i>
        </button>
      </div>
    `

    // Prepend to flash messages container
    flashContainer.insertAdjacentHTML('afterbegin', flashHTML)
  }
}